import { toast } from "react-toastify";

export const SESSION_STORAGE_KEY = `${process.env.REACT_APP_STORAGE_NAMESPACE}_notifications`;

const enqueue = (item: any) => {
  const queue = loadQueueFromSessionStorage();
  queue.push(item);
  saveQueueToSessionStorage(queue);
};

/*const dequeue = () => {
  const queue = loadQueueFromSessionStorage();
  if (queue.length === 0) {
    return null;
  }
  const dequeuedItem = queue.shift();
  saveQueueToSessionStorage(queue);
  return dequeuedItem;
};*/

const dequeueAll = () => {
  const queue = loadQueueFromSessionStorage();
  const dequeuedItems = [...queue];
  saveQueueToSessionStorage([]);
  return dequeuedItems;
};

/*const isEmpty = () => {
  const queue = loadQueueFromSessionStorage();
  return queue.length === 0;
};*/

const saveQueueToSessionStorage = (queue: any) => {
  sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(queue));
};

const loadQueueFromSessionStorage = () => {
  const queueData = sessionStorage.getItem(SESSION_STORAGE_KEY);
  return queueData ? JSON.parse(queueData) : [];
};

export const info = ({
  message,
  onReload = false,
}: {
  message: string;
  onReload?: boolean;
}) => {
  if (!onReload) {
    toast.info(message, {
      position: toast.POSITION.TOP_RIGHT,
    });
  } else {
    enqueue({ message, type: "info", timestamp: Date.now() });
  }
};

export const success = ({
  message,
  onReload = false,
}: {
  message: string;
  onReload?: boolean;
}) => {
  if (!onReload) {
    toast.success(message, {
      position: toast.POSITION.TOP_RIGHT,
    });
  } else {
    enqueue({ message, type: "success", timestamp: Date.now() });
  }
};

export const warning = ({
  message,
  onReload = false,
}: {
  message: string;
  onReload?: boolean;
}) => {
  if (!onReload) {
    toast.warning(message, {
      position: toast.POSITION.TOP_RIGHT,
    });
  } else {
    enqueue({ message, type: "warning", timestamp: Date.now() });
  }
};

export const error = ({
  message,
  onReload = false,
}: {
  message: string;
  onReload?: boolean;
}) => {
  if (!onReload) {
    toast.error(message, {
      position: toast.POSITION.TOP_RIGHT,
    });
  } else {
    enqueue({ message, type: "error", timestamp: Date.now() });
  }
};

const onReload = () => {
  const now = Date.now();
  const dequeuedItems = dequeueAll();

  dequeuedItems.forEach((item) => {
    const { message, type, timestamp} = item;

    const itemAgeInSeconds = (now - timestamp) / 1000;

    if (itemAgeInSeconds <= 30) {
      switch (type) {
        case "error":
          error({message});
          break;
        case "warning":
          warning({message});
          break;
        case "success":
          success({message});
          break;
        case "info":
          info({message});
          break;
        default:
          console.error("Unknown alert type:", type);
      }
    }
  });
};

const notifications = {
  info,
  success,
  warning,
  error,
  onReload,
}

export default notifications;
